import store from '@/store'
import {
  ExecuteMassiveAction,
  ExportDmsNotifications,
  Firestore,
  MassiveActionsDoc,
  GroupDoc,
  UsersDoc,
} from '../firebase-exports'

/**
 * Sets the status of several notifications.
 * @param {String} userId Id of the user.
 * @param {Array} items Ids of the notifications to update.
 * @param {String} status Status to set.
 */
export const massiveActionChangeStatus = async (
  userId,
  items,
  status,
  absentUserId
) => {
  await ExecuteMassiveAction({
    userId,
    items,
    status,
    action: 'changeStatus',
    absentUserId,
  })
}

/**
 * Opens several notifications at once.
 * @param {String} userId Id of the user.
 * @param {Array} items Ids of the notifications to update.
 */
export const massiveOpenNotification = async (userId, items, absentUserId) => {
  await ExecuteMassiveAction({
    userId,
    items,
    action: 'openNotification',
    absentUserId,
  })
}

/**
 * Sets a responsible to several notifications.
 * @param {String} userId Id of the user with the notifications.
 * @param {Object} manager Object of the operator or Group to set.
 * @param {Array} items Ids of the notifications to set as responsible.
 */
export const massiveSetResponsible = async (
  userId,
  manager,
  items,
  absentUserId
) => {
  const managerPath = await resolveManagerPath(manager, userId)

  await ExecuteMassiveAction({
    userId,
    managerPath,
    items,
    action: 'setResponsible',
    absentUserId,
  })
}

export const resolveManagerPath = async (manager, userId) => {
  if (manager?.ref?.path) return manager.ref.path

  const docRef = manager.isGroup
    ? GroupDoc(userId, manager.id)
    : UsersDoc(manager.id)

  const docSnap = await Firestore.getDoc(docRef)
  if (!docSnap.exists()) return

  return docSnap.ref.path
}

/**
 * Sets an alert to several notifications.
 * @param {String} userId Id of the user with the notifications.
 * @param {Object} alert Alert object.
 * @param {Array} items Ids of the notifications to set an alert.
 */
export const massiveSetAlert = async (userId, alert, items, absentUserId) => {
  await ExecuteMassiveAction({
    userId,
    alert,
    items,
    action: 'setAlert',
    absentUserId,
  })
}

/**
 * Sets an observation to several notifications.
 * @param {String} userId Id of the user with the notifications.
 * @param {String} observation Observation to stablish.
 * @param {Array} items Ids of the notifications to add an observation.
 */
export const massiveSetObservation = async (
  userId,
  observation,
  items,
  absentUserId
) => {
  await ExecuteMassiveAction({
    userId,
    observation,
    items,
    action: 'setObservation',
    absentUserId,
  })
}

/**
 * Downloads the files of all the notifications.
 * @param {Array} notifications Ids of the notifications to download.
 */
export const massiveDownloadFiles = async (
  userId,
  notifications,
  absentUserId
) => {
  await ExportDmsNotifications({
    notifications,
    userId,
    action: 'downloadFiles',
    absentUserId,
  })
}

export const getMassiveActionsSettings = async () => {
  const docSnap = await Firestore.getDoc(MassiveActionsDoc())
  if (!docSnap.exists()) return

  // Guardamos en el store solo el atributo que necesitamos en esta app de cliente
  store.commit('setMassiveActionsSettings', docSnap.data())

  return docSnap.data()
}
